import { TemplateRef } from '@angular/core';

import { Fixture } from '@cds/betting-offer';
import { PicksView } from '@cds/betting-offer/domain-specific';
import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { createAction, props } from '@ngrx/store';
import { BetBuilderMarket } from 'packages/sports/web/app/src/betbuilder/model/bet-builder.model';
import { OptionRequest } from 'packages/sports/web/app/src/navigation-core/pick-uri.model';
import { NumpadAction } from 'packages/sports/web/app/src/numpad/model';

import BetslipActions from '../../base/store/actions';
import { BetslipType } from '../../core/betslip-type';
import { BABAdditionalInfo, BetBuilderV1EventData, PickAddPayload } from '../../core/external-betslip-actions';
import { BetslipGroupInformation } from '../../core/groups/betslip-group-information';
import { BetslipBetBuilderPick } from '../../core/picks/betslip-bet-builder-pick';
import { BaseBetslipGroupPick } from '../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../core/picks/betslip-pick';
import { BetslipV1Pick } from '../../core/picks/betslip-v1-pick';
import { BetslipV2Pick } from '../../core/picks/betslip-v2-pick';
import { BetBuilderPickId, PickId, V1PickId, V2OptionMarketPickId, V2OptionMarketXCastPickId, V2ParticipantPickId } from '../../core/picks/pick-id';
import { IPickTracking, PickUpdateType } from '../../core/picks/pick-models';
import { ReplacePickPayload } from './replace-pick-payload';

export default class BetslipPickActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/pick`;

    private static readonly REQUEST_ADD_PICK = `${BetslipPickActions.ACTION_SCHEMA}/REQUEST_ADD_PICK`;
    private static readonly REQUEST_ADD_GROUP_PICK = `${BetslipPickActions.ACTION_SCHEMA}/REQUEST_ADD_GROUP_PICK`;
    private static readonly REQUEST_ADD_BET_BUILDER_PICK = `${BetslipPickActions.ACTION_SCHEMA}/REQUEST_ADD_BET_BUILDER_PICK`;
    private static readonly REQUEST_ADD_ENTAIN_UI_BET_BUILDER_PICK = `${BetslipPickActions.ACTION_SCHEMA}/REQUEST_ADD_ENTAIN_UI_BET_BUILDER_PICK`;
    private static readonly ADD_ENTAIN_UI_BET_BUILDER_PICK = `${BetslipPickActions.ACTION_SCHEMA}/ADD_ENTAIN_UI_BET_BUILDER_PICK`;
    private static readonly REQUEST_REMOVE_PICK = `${BetslipPickActions.ACTION_SCHEMA}/REQUEST_REMOVE_PICK`;
    private static readonly REQUEST_REMOVE_BET_BUILDER_PICK = `${BetslipPickActions.ACTION_SCHEMA}/REQUEST_REMOVE_BET_BUILDER_PICK`;
    private static readonly REQUEST_REPLACE_PRE_CREATED_BET_BUILDER_PICK = `${BetslipPickActions.ACTION_SCHEMA}/REQUEST_REPLACE_PRE_CREATED_BET_BUILDER_PICK`;
    private static readonly CHECK_PRECREATED_BAB_CONVERSION = `${BetslipPickActions.ACTION_SCHEMA}/CHECK_PRECREATED_BAB_CONVERSION`;

    private static readonly ADD_PICK = `${BetslipPickActions.ACTION_SCHEMA}/ADD_PICK`;
    private static readonly REMOVE_PICK = `${BetslipPickActions.ACTION_SCHEMA}/REMOVE_PICK`;
    private static readonly REMOVE_MULTIPLE_PICKS = `${BetslipPickActions.ACTION_SCHEMA}/REMOVE_MULTIPLE_PICKS`;
    private static readonly REMOVED_PICK = `${BetslipPickActions.ACTION_SCHEMA}/REMOVED_PICK`;
    private static readonly REMOVED_MULTIPLE_PICK = `${BetslipPickActions.ACTION_SCHEMA}/REMOVED_MULTIPLE_PICK`;
    private static readonly REQUEST_REMOVE_MULTIPLE_PICKS = `${BetslipPickActions.ACTION_SCHEMA}/REQUEST_REMOVE_MULTIPLE_PICKS`;
    private static readonly REQUEST_REMOVE_ALL_PICKS = `${BetslipPickActions.ACTION_SCHEMA}/REQUEST_REMOVE_ALL_PICKS`;
    private static readonly REQUEST_REMOVE_PICKS_FROM_GROUP = `${BetslipPickActions.ACTION_SCHEMA}/REQUEST_REMOVE_PICKS_FROM_GROUP`;
    private static readonly REQUEST_REMOVE_PLACED_PICKS_FROM_GROUP = `${BetslipPickActions.ACTION_SCHEMA}/REQUEST_REMOVE_PLACED_PICKS_FROM_GROUP`;
    private static readonly TOGGLE_PICK = `${BetslipPickActions.ACTION_SCHEMA}/TOGGLE_PICK`;
    private static readonly TOGGLE_PICK_FOR_TYPE = `${BetslipPickActions.ACTION_SCHEMA}/TOGGLE_PICK_FOR_TYPE`;
    private static readonly TOGGLE_ALL_PICKS = `${BetslipPickActions.ACTION_SCHEMA}/TOGGLE_ALL_PICKS`;
    private static readonly SELECT_PICK = `${BetslipPickActions.ACTION_SCHEMA}/SELECT_PICK`;
    private static readonly DESELECT_PICK = `${BetslipPickActions.ACTION_SCHEMA}/DESELECT_PICK`;
    private static readonly CHANGE_SELECTION = `${BetslipPickActions.ACTION_SCHEMA}/CHANGE_SELECTION`;
    private static readonly SET_FIXED_PRICE = `${BetslipPickActions.ACTION_SCHEMA}/SET_FIXED_PRICE`;
    private static readonly SET_STARTING_PRICE = `${BetslipPickActions.ACTION_SCHEMA}/SET_STARTING_PRICE`;
    private static readonly TOGGLE_WIN_PICK = `${BetslipPickActions.ACTION_SCHEMA}/TOGGLE_WIN_PICK`;
    private static readonly ACCEPT_CURRENT_PRICE = `${BetslipPickActions.ACTION_SCHEMA}/ACCEPT_CURRENT_PRICE`;
    private static readonly ADD_PICK_HIGHLIGHT = `${BetslipPickActions.ACTION_SCHEMA}/ADD_PICK_HIGHLIGHT`;
    private static readonly ADD_PICKS_HIGHLIGHT = `${BetslipPickActions.ACTION_SCHEMA}/ADD_PICKS_HIGHLIGHT`;
    private static readonly REMOVE_PICK_HIGHLIGHT = `${BetslipPickActions.ACTION_SCHEMA}/REMOVE_PICK_HIGHLIGHT`;
    private static readonly REMOVE_PICKS_HIGHLIGHT = `${BetslipPickActions.ACTION_SCHEMA}/REMOVE_PICKS_HIGHLIGHT`;
    private static readonly SCROLL_TO_PICK = `${BetslipPickActions.ACTION_SCHEMA}/SCROLL_TO_PICK`;
    private static readonly EXPAND_BET_BUILDER_LEGS = `${BetslipPickActions.ACTION_SCHEMA}/EXPAND_BET_BUILDER_LEGS`;
    private static readonly COLLAPSE_BET_BUILDER_LEGS = `${BetslipPickActions.ACTION_SCHEMA}/COLLAPSE_BET_BUILDER_LEGS`;

    private static readonly UPDATE_V1_PICKS = `${BetslipPickActions.ACTION_SCHEMA}/UPDATE_V1_PICKS`;
    private static readonly UPDATE_V2_PICKS = `${BetslipPickActions.ACTION_SCHEMA}/UPDATE_V2_PICKS`;
    private static readonly UPDATE_GROUP_PICKS = `${BetslipPickActions.ACTION_SCHEMA}/UPDATE_GROUP_PICKS`;
    private static readonly UPDATE_GROUP_PICK_LEGS = `${BetslipPickActions.ACTION_SCHEMA}/UPDATE_GROUP_PICK_LEGS`;

    private static readonly REPLACE_PICK = `${BetslipPickActions.ACTION_SCHEMA}/REPLACE_PICK`;

    private static readonly SET_SOURCE_OF_BET = `${BetslipPickActions.ACTION_SCHEMA}/SET_SOURCE_OF_BET`;
    private static readonly SET_SOURCE_OF_BET_SUFFIX = `${BetslipPickActions.ACTION_SCHEMA}/SET_SOURCE_OF_BET_SUFFIX`;
    private static readonly SET_MULTIPLE_SOURCE_OF_BET_SUFFIX = `${BetslipPickActions.ACTION_SCHEMA}/SET_MULTIPLE_SOURCE_OF_BET_SUFFIX`;
    private static readonly SET_NUMPAD_ACTION = `${BetslipPickActions.ACTION_SCHEMA}/SET_NUMPAD_ACTION`;
    private static readonly ADD_AFFILIATE_REQUEST = `${BetslipPickActions.ACTION_SCHEMA}/PROCESS_AFFILIATE_REQUEST`;
    private static readonly SHARE_AFFILIATE_PICKS = `${BetslipPickActions.ACTION_SCHEMA}/SHARE_AFFILIATE_PICKS`;
    static readonly PICK_SELECTION_CHANGED = `${BetslipPickActions.ACTION_SCHEMA}/PICK_SELECTION_CHANGED`;
    private static readonly ADD_WEB_APP_PICK = `${BetslipPickActions.ACTION_SCHEMA}/ADD_WEB_APP_PICK`;
    private static readonly REMOVE_WEB_APP_PICK = `${BetslipPickActions.ACTION_SCHEMA}/REMOVE_WEB_APP_PICK`;

    private static readonly PICKS_REFRESHED = `${BetslipPickActions.ACTION_SCHEMA}/PICKS_REFRESHED`;
    private static readonly REFRESH_GROUP_PICK = `${BetslipPickActions.ACTION_SCHEMA}/REFRESH_GROUP_PICK`;

    private static readonly CHANGE_LOCK_STATE = `${BetslipPickActions.ACTION_SCHEMA}/CHANGE_LOCK_STATE`;

    private static readonly ADD_LAST_PICK_ERROR = `${BetslipPickActions.ACTION_SCHEMA}/ADD_LAST_PICK_ERROR`;
    private static readonly REMOVE_LAST_PICK_ERROR = `${BetslipPickActions.ACTION_SCHEMA}/REMOVE_LAST_PICK_ERROR`;
    private static readonly LAST_PICK_ERROR_REMOVE_PICK_ID = `${BetslipPickActions.ACTION_SCHEMA}/LAST_PICK_ERROR_REMOVE_PICK_ID`;
    private static readonly REMOVE_LAST_PICK_FROM_PICK_LIST = `${BetslipPickActions.ACTION_SCHEMA}/REMOVE_LAST_PICK_FROM_PICK_LIST`;

    private static readonly REMOVE_TYPE_PICKS = `${BetslipPickActions.ACTION_SCHEMA}/REMOVE_TYPE_PICKS`;

    /**
     * Action called with request to add v1 or option market pick to betslip
     */
    static requestAddPick = createAction(
        BetslipPickActions.REQUEST_ADD_PICK,
        props<{
            pickId: V1PickId | V2OptionMarketPickId | V2ParticipantPickId | V2OptionMarketXCastPickId;
            tracking: IPickTracking;
            sportId?: number;
            priceId?: number;
            isPriceBoosted?: boolean;
            groupInfo?: BetslipGroupInformation;
            parentLinkedEventId?: string;
            isBetBuilderEnabled: boolean;
        }>(),
    );

    /**
     * Action called with request to add several v1 or option market picks in a SGP group to betslip
     */
    static requestAddGroupPick = createAction(
        BetslipPickActions.REQUEST_ADD_GROUP_PICK,
        props<{ payload: PickAddPayload[]; headerTemplate?: TemplateRef<any> }>(),
    );

    /**
     * Action called with request to add bet builder pick to betslip, when v1
     */
    static requestAddBetBuilderPick = createAction(
        BetslipPickActions.REQUEST_ADD_BET_BUILDER_PICK,
        props<{ pickId: BetBuilderPickId; tracking: IPickTracking; eventData: BetBuilderV1EventData | null; additionalInfo?: BABAdditionalInfo }>(),
    );

    /**
     * Action called with request to add entain ui bet builder pick
     */
    static requestAddEntainUiBetBuilderPick = createAction(
        BetslipPickActions.REQUEST_ADD_ENTAIN_UI_BET_BUILDER_PICK,
        props<{
            pickId: BetBuilderPickId;
            tracking: IPickTracking;
            eventData: BetBuilderV1EventData;
            eventModel: EventModel;
            market: BetBuilderMarket;
            longId: string[];
            headerTemplate?: TemplateRef<any>;
            isPrecreatedBAB?: boolean;
        }>(),
    );

    /**
     * Action called with request to remove entain ui bet builder pick
     */
    static requestRemoveEntainUiBetBuilderPick = createAction(
        BetslipPickActions.REQUEST_REMOVE_BET_BUILDER_PICK,
        props<{
            pickId: BetBuilderPickId;
            longId: string;
            eventId: string;
            eventName?: string;
        }>(),
    );

    /**
     * Action called with request to check if there is already a customized BAB for the event on the betslip
     */
    static checkPrecreatedBABConversion = createAction(
        BetslipPickActions.CHECK_PRECREATED_BAB_CONVERSION,
        props<{
            pickId: BetBuilderPickId;
            headerTemplate: TemplateRef<any>;
            eventModel?: EventModel;
            market?: BetBuilderMarket;
            eventData?: BetBuilderV1EventData;
            longId?: string[];
            isBetslip?: boolean;
        }>(),
    );

    /**
     * Action called with request to replace Pre-created BAB with customized BAB
     */
    static requestReplacePreCreatedBetBuilderPick = createAction(
        BetslipPickActions.REQUEST_REPLACE_PRE_CREATED_BET_BUILDER_PICK,
        props<{
            pickId: BetBuilderPickId;
            headerTemplate: TemplateRef<any>;
            tracking: IPickTracking;
        }>(),
    );

    /**
     * Add new pick to the slip.
     */
    static addPick = createAction(BetslipPickActions.ADD_PICK, props<{ pick: BetslipPick }>());

    /**
     * Request Remove pick from the slip
     */
    static requestRemovePick = createAction(BetslipPickActions.REQUEST_REMOVE_PICK, props<{ pickId: PickId; eventName?: string }>());

    /**
     * Remove pick from the slip
     */
    static removePick = createAction(
        BetslipPickActions.REMOVE_PICK,
        props<{
            pickId: PickId;
            eventName?: string;
            skipPickTypeStateCleanup?: boolean;
            skipPickSubscriptionCleanup?: boolean;
            groupInfo?: BetslipGroupInformation;
            //Relevant in case of groups, we pass it to take care of relevant state changes, for example subscriptions and bet types pick state
            childrenPickIds?: PickId[];
        }>(),
    );

    /**
     * Removed pick from the slip
     */
    static removedPick = createAction(BetslipPickActions.REMOVED_PICK, props<{ pickId: PickId }>());

    /**
     * Request remove multiple picks from the slip
     */
    static requestRemoveMultiplePicks = createAction(BetslipPickActions.REQUEST_REMOVE_MULTIPLE_PICKS, props<{ pickIds: PickId[] }>());

    /**
     * Request remove all picks from the slip
     */
    static requestRemoveAllPicks = createAction(BetslipPickActions.REQUEST_REMOVE_ALL_PICKS);

    /**
     * Remove multiple picks from the slip
     */
    static removeMultiplePicks = createAction(BetslipPickActions.REMOVE_MULTIPLE_PICKS, props<{ pickIds: PickId[] }>());

    /**
     * Removed multiple picks from the slip
     */
    static removedMultiplePicks = createAction(BetslipPickActions.REMOVED_MULTIPLE_PICK, props<{ pickIds: PickId[] }>());

    /**
     * Action called with request to remove several picks from a SGP group to betslip
     */
    static requestRemovePicksFromGroup = createAction(BetslipPickActions.REQUEST_REMOVE_PICKS_FROM_GROUP, props<{ pickIds: PickId[] }>());

    /**
     * Action called with request to remove several picks after bet placement
     */
    static requestRemovePlacedPicksFromGroup = createAction(
        BetslipPickActions.REQUEST_REMOVE_PLACED_PICKS_FROM_GROUP,
        props<{ pickIds: PickId[] }>(),
    );

    /**
     * Toggle pick selection
     */
    static togglePick = createAction(BetslipPickActions.TOGGLE_PICK, props<{ pickId: PickId }>());

    /**
     * Toggle pick selection
     */
    static togglePickForType = createAction(
        BetslipPickActions.TOGGLE_PICK_FOR_TYPE,
        props<{ pickId: PickId; betslipType: BetslipType; newSelectionState: boolean }>(),
    );

    /**
     * Toggle all picks
     */
    static toggleAllPicks = createAction(BetslipPickActions.TOGGLE_ALL_PICKS, props<{ select: boolean }>());

    /**
     * Select pick, Use the pick in bet placement
     */
    static selectPick = createAction(BetslipPickActions.SELECT_PICK, props<{ pickId: PickId }>());

    /**
     * De select pick. The pick will continue be in the slip, but will not be used in the placement
     */
    static deselectPick = createAction(BetslipPickActions.DESELECT_PICK, props<{ pickId: PickId }>());

    /**
     * Change selection for list of picks, if selection is true select picks, if selection is false deselect them
     */
    static changeSelection = createAction(BetslipPickActions.CHANGE_SELECTION, props<{ pickIds: PickId[]; selection: boolean }>());

    static changeLockState = createAction(BetslipPickActions.CHANGE_LOCK_STATE, props<{ pickIds: PickId[]; isLocked: boolean }>());

    /**
     * Use Fixed price for the pick
     */
    static setFixedPrice = createAction(BetslipPickActions.SET_FIXED_PRICE, props<{ pickId: PickId }>());

    /**
     * Use starting price for the pick
     */
    static setStartingPrice = createAction(BetslipPickActions.SET_STARTING_PRICE, props<{ pickId: PickId }>());

    /**
     * Toggle win or sp pick
     */
    static toggleWinPick = createAction(
        BetslipPickActions.TOGGLE_WIN_PICK,
        props<{ pickId: V1PickId | V2OptionMarketPickId | V2ParticipantPickId | V2OptionMarketXCastPickId }>(),
    );

    /**
     * Accept current price
     */
    static acceptCurrentPrice = createAction(BetslipPickActions.ACCEPT_CURRENT_PRICE, props<{ pickIds: PickId[]; isManuallyAccepted: boolean }>());

    /**
     * Updates the pick UI state by setting the legs state to expanded
     */
    static expandBetBuilderLegs = createAction(BetslipPickActions.EXPAND_BET_BUILDER_LEGS, props<{ pickId: PickId }>());

    /**
     * Updates the pick UI state by setting the legs state to collapsed
     */
    static collapseBetBuilderLegs = createAction(BetslipPickActions.COLLAPSE_BET_BUILDER_LEGS, props<{ pickId: PickId }>());

    /**
     * Highlight pick
     */
    static addPickHighlight = createAction(BetslipPickActions.ADD_PICK_HIGHLIGHT, props<{ pickId: PickId; autoRestore: boolean }>());

    /**
     * Highlight multiple picks at same time
     */
    static addPicksHighlight = createAction(
        BetslipPickActions.ADD_PICKS_HIGHLIGHT,
        props<{ payload: { pickIds: PickId[]; autoRestore: boolean } }>(),
    );

    /**
     * Remove highlighting of the pick
     */
    static removePickHighlight = createAction(BetslipPickActions.REMOVE_PICK_HIGHLIGHT, props<{ pickId: PickId }>());

    /**
     * Remove highlighting of multiple picks
     */
    static removePicksHighlight = createAction(BetslipPickActions.REMOVE_PICKS_HIGHLIGHT, props<{ pickIds: PickId[] }>());

    /**
     * Scroll to pick
     */
    static scrollToPick = createAction(BetslipPickActions.SCROLL_TO_PICK, props<{ pickId: PickId }>());

    /**
     * Update V1 Picks
     */
    static updateV1Picks = createAction(
        BetslipPickActions.UPDATE_V1_PICKS,
        props<{ pickUpdates: { pick: BetslipV1Pick; updateType: PickUpdateType }[]; byPassErrorClear?: boolean }>(),
    );

    /**
     * Update V2 Picks
     */
    static updateV2Picks = createAction(
        BetslipPickActions.UPDATE_V2_PICKS,
        props<{ pickUpdates: { pick: BetslipV2Pick; updateType: PickUpdateType }[]; byPassErrorClear?: boolean }>(),
    );

    /**
     * Update Group Picks
     */
    static updateGroupPicks = createAction(
        BetslipPickActions.UPDATE_GROUP_PICKS,
        props<{ pickUpdates: { pick: BaseBetslipGroupPick; updateType: PickUpdateType }[]; byPassErrorClear?: boolean }>(),
    );

    static updateGroupPickLegs = createAction(
        BetslipPickActions.UPDATE_GROUP_PICK_LEGS,
        props<{ pickUpdates: { pick: BetslipPick; updateType: PickUpdateType }[] }>(),
    );

    /**
     * Replaces the pick in the state. Payload contains the Id of the pick to be replaced and the new pick.
     * TODO (optional) atBetPlacement prop added to fix INC1471873, but overall we should aim to have quick bet ui state set to QuickBetUiState.Place (in the future)
     */
    static replacePick = createAction(BetslipPickActions.REPLACE_PICK, props<ReplacePickPayload>());

    /**
     * Set SourceOfBet
     */
    static setSourceOfBet = createAction(BetslipPickActions.SET_SOURCE_OF_BET, props<{ pickId: PickId; source: string; affiliate?: boolean }>());

    /**
     * Set setSourceOfBetSuffix
     */
    static setSourceOfBetSuffix = createAction(BetslipPickActions.SET_SOURCE_OF_BET_SUFFIX, props<{ pickId: PickId; suffix: string }>());

    static setMultipleSourceOfBetSuffix = createAction(
        BetslipPickActions.SET_MULTIPLE_SOURCE_OF_BET_SUFFIX,
        props<{ pickIds: PickId[]; suffix: string }>(),
    );

    /**
     * Set Tracking Numpad Action
     */
    static setTrackingNumpadAction = createAction(BetslipPickActions.SET_NUMPAD_ACTION, props<{ pickIds: PickId[]; action: NumpadAction }>());

    /**
     * Add Affiliate Picks
     */
    static addAffiliatePicks = createAction(BetslipPickActions.ADD_AFFILIATE_REQUEST, props<{ request: OptionRequest; picksView: PicksView }>());

    /**
     * Add Affiliate Picks
     */
    static shareAffiliatePicks = createAction(BetslipPickActions.SHARE_AFFILIATE_PICKS);

    /**
     * Action when selection is changed b/w WIN and SP markets in betslip area
     */
    static pickSelectionChanged = createAction(BetslipPickActions.PICK_SELECTION_CHANGED, props<PickAddPayload>());

    /*
     * Add Pick via web bridge service (e.g. used for AB testing)
     */
    static addWebAppPick = createAction(BetslipPickActions.ADD_WEB_APP_PICK, props<{ fixture: Fixture; option: number }>());

    static picksRefreshed = createAction(BetslipPickActions.PICKS_REFRESHED);
    static removeWebAppPick = createAction(BetslipPickActions.REMOVE_WEB_APP_PICK, props<{ fixture: Fixture; option: number }>());

    static addLastPickError = createAction(BetslipPickActions.ADD_LAST_PICK_ERROR, props<{ pickId: PickId }>());
    static removeLastPickError = createAction(BetslipPickActions.REMOVE_LAST_PICK_ERROR);
    static lastPickErrorRemovePickId = createAction(BetslipPickActions.LAST_PICK_ERROR_REMOVE_PICK_ID);
    static removeLastPickFromPickList = createAction(BetslipPickActions.REMOVE_LAST_PICK_FROM_PICK_LIST);
    static refreshGroupPick = createAction(BetslipPickActions.REFRESH_GROUP_PICK, props<{ pick: BaseBetslipGroupPick }>());
    static addEntainUiBetBuilderPick = createAction(
        BetslipPickActions.ADD_ENTAIN_UI_BET_BUILDER_PICK,
        props<{ pick: BetslipBetBuilderPick; isPrecreatedBAB: boolean; headerTemplate?: TemplateRef<any> }>(),
    );

    static removeTypePicks = createAction(BetslipPickActions.REMOVE_TYPE_PICKS, props<{ pickIds: PickId[] }>());
}
